import * as React from "react";

import { cn } from "~/lib/utils";

export function EmptyState({
  title,
  children,
  action,
  className,
}: {
  title?: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex flex-col items-center gap-3 border border-line-hairline bg-surface-sunken px-6 py-10 text-center text-sm text-fg-muted",
        className,
      )}
    >
      {title ? (
        <p className="font-display text-lg font-medium tracking-[-0.02em] text-fg-strong">
          {title}
        </p>
      ) : null}
      {children ? <p className="max-w-[52ch] text-pretty">{children}</p> : null}
      {action}
    </div>
  );
}
